import * as tslib_1 from "tslib";
import QuickOptionEntry from './QuickOptionEntry';
import QuickOptionSearchEntry from './QuickOptionSearchEntry';
import mountAndShowFullOptions from '../../utils/mountAndShowFullOptions';
import { setSearchTerm, getSearchResults, getQuery } from 'owa-options-search';
import { getQuickOptions } from 'owa-options-store';
import { observer } from 'mobx-react';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { SettingPanelFirstRunCallout } from './SettingPanelFirstRunCallout';
import * as ReactDOM from 'react-dom';
import { LightningId } from 'owa-lightning';
import { resetSearch } from 'owa-options-search';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
var styles = require('./QuickOptions.scss');
var classNames = require('classnames/bind').bind(styles);
var QuickOptions = /** @class */ (function (_super) {
    tslib_1.__extends(QuickOptions, _super);
    function QuickOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onDismiss = function () {
            if (_this.props.onDismiss) {
                resetSearch(false /*successfulSearch*/);
                _this.props.onDismiss();
            }
        };
        _this.goToFullOptions = function () {
            mountAndShowFullOptions();
            _this.onDismiss();
        };
        return _this;
    }
    QuickOptions.prototype.render = function () {
        var _this = this;
        var isSearch = !!getQuery();
        var displayedOptions = isSearch ? getSearchResults() : getQuickOptions();
        var target;
        return (React.createElement("div", { className: classNames(styles.container, isControlFeatureEnabled('fwk-o365shellheader') && styles.noDark) },
            React.createElement(SearchBox, { labelText: strings.optionsFlex_searchPlaceholder, value: getQuery(), onChange: setSearchTerm }),
            React.createElement("div", { className: styles.quickSettingsPanel },
                displayedOptions.map(function (option, index) {
                    return isSearch ? (React.createElement(QuickOptionSearchEntry, { onDismiss: _this.props.onDismiss, option: option, key: option.key })) : (React.createElement(QuickOptionEntry, { ref: function (ref) {
                            if (index == 0) {
                                target = ReactDOM.findDOMNode(ref);
                            }
                        }, onDismiss: _this.props.onDismiss, option: option, key: option.key }));
                }),
                isSearch &&
                    displayedOptions.length == 0 && (React.createElement("div", { className: styles.quickSetting },
                    React.createElement("span", { className: classNames(styles.quickSettingHeader, styles.noResults) }, strings.optionsFull_search_noResults))),
                React.createElement(SettingPanelFirstRunCallout, { lid: LightningId.SettingPanelFirstRunCallout, when: function (lightup) { return lightup(); }, series: [
                        LightningId.AnimatedConsumerRefreshFRE2,
                        LightningId.SettingPanelFirstRunCallout,
                        LightningId.SettingIconFirstRunCallout,
                    ], target: function () { return target; } })),
            React.createElement(CommandButton, { className: styles.viewFullSettings, onClick: this.goToFullOptions },
                React.createElement("span", null, strings.optionsFlex_goToFullOptions),
                React.createElement(Icon, { iconName: "ChevronRight" /* ChevronRight */, className: classNames(styles.icon, 'flipForRtl') }))));
    };
    QuickOptions.prototype.componentWillUnmount = function () {
        this.onDismiss();
    };
    QuickOptions = tslib_1.__decorate([
        observer
    ], QuickOptions);
    return QuickOptions;
}(React.Component));
export default QuickOptions;
//# sourceMappingURL=QuickOptions.js.map